import { SET_DRAFT_DATA } from "../../redux/actions/action.types";

export default function setDraftData(draftDataSetter: any, draftData: any) {
  draftData.length !== 0 &&
    draftDataSetter({
      type: SET_DRAFT_DATA,
      payload: draftData,
    });
}
